import React, { useState, useEffect,useRef } from "react";
import { createRoot } from "react-dom/client";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Bounce, toast } from "react-toastify";

// CSS
import "./css/wizard-menu.css";

// Pages
import Business from "./pages/Business";
import Store from "./pages/Store";
import Account from "./pages/Account";
import Payment from "./pages/Payment";
import Success from "./pages/Success";

const logo = `${EASYCOMMERCE.assets}common/img/logo.svg`;
const check = `${EASYCOMMERCE.assets}admin/img/icons/check.png`;

const tabs = ["/business", "/store","/payment", "/account", "/success"];
const defaultTab = tabs[0];

const App = () => {
    const formRef = useRef();
    const [activeTab, setActiveTab] = useState(
        window.location.hash.replace("#", "") || defaultTab
    );
    const [isAPIKeyVisible, setIsAPIKeyVisible] = useState(false);

    const showToast = (type, message) => {
        toast[type](message, {
            position: "top-right",
            style: {
                margin: "30px 0 0 0",
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "26px",
                color: "#fff",
            },
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
        });
    };

    const [formValues, setFormValues] = useState({
        store_name: "",
        logo: "",
        business_type: "",
        country: "",
        email: "",
        shop: "",
        checkout: "",
        dashboard: "",
        currency: "",
        format : "",
        payment_methods: [],
        name: "",
        apiKey: "",
        dont_share_data: false
      });

    //get form data initially
    useEffect(() => {
        fetch(`${EASYCOMMERCE.rest_base}/connectivity/setup/get`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-WP-Nonce": EASYCOMMERCE.nonce,
            },
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success && data?.data?.data) {
                    const d = data.data.data;
                    console.log(d);
                    setFormValues({
                        store_name: d.store_name || "",
                        logo: d.logo || "",
                        business_type: d.business_type || "",
                        country: d.country || "",
                        email: d.business_email || "",
                        shop: d.shop || "",
                        checkout: d.checkout || "",
                        dashboard: d.dashboard || "",
                        currency: d.currency || "",
                        format : d.format || "",
                        payment_methods: d.payment_methods || [],
                        name: d.name || EASYCOMMERCE.user.data.display_name,
                    });
                }
            });
    }, []);

    useEffect(() => {
        const handleHashChange = () => {
            const newHash = window.location.hash.replace("#", "");
            if (tabs.includes(newHash)) {
                setActiveTab(newHash);
            } else {
                setActiveTab(defaultTab);
                window.location.hash = defaultTab;
            }
        };

        window.addEventListener("hashchange", handleHashChange);
        handleHashChange();

        return () => {
            window.removeEventListener("hashchange", handleHashChange);
        };
    }, []);

    const saveDataToAPI = () => {
        const formDataObject = new FormData(formRef.current);
        const entries        = Object.fromEntries(formDataObject.entries());
        const paymentMethods = formDataObject.getAll('payment-methods-active_methods');

        entries['payment-methods-active_methods'] = paymentMethods;
    
        console.log(entries);

        fetch(`${EASYCOMMERCE.rest_base}/connectivity/setup/save`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-WP-Nonce": EASYCOMMERCE.nonce,
            },
            body: JSON.stringify({
                type: activeTab.replace("/", ""),
                data: entries
                }),
            })
            .then((res) => res.json())
            .then((result) => {
            console.log("Saved:", result);
            });
    };
    const handleNext = () => {
        const currentIndex = tabs.indexOf(activeTab);

        if (activeTab === "/account") {
            if (!isAPIKeyVisible) {
                easycommerce_modal(true);
                fetch(`${EASYCOMMERCE.rest_base}/connectivity/token`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-WP-Nonce": EASYCOMMERCE.nonce,
                    },
                    body: JSON.stringify({
                        name: formValues.name,
                        email: formValues.email,
                    }),
                })
                .then(response => response.json())
                    .then(data => {
                        setTimeout(() => {
                            easycommerce_modal(false);
                            if (data.success) {
                                setIsAPIKeyVisible(true);
                                showToast("success","API Key Sent to your email");
                            } else {
                                showToast("error", "Failed to send API key");
                            }
                        }, 1000);
                    })
                    .catch(() => {
                        showToast("error", "Something went wrong");
                });
                
            } else {
                if (currentIndex < tabs.length - 1) {
                    if (
                        activeTab === "/account" &&
                        formValues.email &&
                        formValues.apiKey
                    ) {
                        easycommerce_modal(true);
                        fetch(`${EASYCOMMERCE.rest_base}/connectivity/token/verify`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "X-WP-Nonce": EASYCOMMERCE.nonce,
                            },
                            body: JSON.stringify({
                                email: formValues.email,
                                token: formValues.apiKey,
                            }),
                        })
                        .then(response => response.json())
                            .then(data => {
                                easycommerce_modal(false);
                                if (data.success && data.data?.verified) {
                                    showToast("success", "API Key Verified Successfully");
                                    const nextTab = tabs[currentIndex + 1];
                                    setActiveTab(nextTab);
                                    window.location.hash = nextTab;
                                    window.scrollTo({ top: 0, behavior: "smooth" });
                                } else {
                                    showToast("error", "API Key verification failed");
                                }
                            })
                            .catch(() => {
                                easycommerce_modal(false);
                                showToast("error", "Something went wrong");
                        });
                    }
                }
            }
        } else {
            if (currentIndex < tabs.length - 1) {
                const nextTab = tabs[currentIndex + 1];
                setActiveTab(nextTab);
                window.location.hash = nextTab;
                window.scrollTo({ top: 0, behavior: "smooth" });

                saveDataToAPI(); 
            }
        }
    };

    
    const handlePrevious = () => {
        const currentIndex = tabs.indexOf(activeTab);
        if (currentIndex > 0) {
            const prevTab = tabs[currentIndex - 1];
            setActiveTab(prevTab);
            window.location.hash = prevTab;
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    const handleSkip = () => {
        const currentIndex = tabs.indexOf(activeTab);
        if (currentIndex < tabs.length - 1) {
            const nextTab = tabs[currentIndex + 1];
            setActiveTab(nextTab);
            window.location.hash = nextTab;
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    const getStepClassName = (index) => {
        const currentIndex = tabs.indexOf(activeTab);
        if (currentIndex > index) {
            return "bg-ec-primary text-white";
        } else if (currentIndex === index) {
            return "bg-ec-primary text-white";
        } else {
            return "border-2 border-[#E0E8FF] text-ec-secondary bg-[#EEF2FF]";
        }
    };

    const progressWidth = `${
        (tabs.indexOf(activeTab) / (tabs.length - 1)) * 95
    }%`;

    return (
        <div
            className={`bg-[#EEF2FF] ${
                activeTab === "/account" && "h-screen"
            } flex justify-center items-center`}
        >
            <div className="w-full h-full flex flex-col items-center">
                {activeTab !== "/success" && (
                    <>
                        <div className="flex justify-center py-[60px] w-[40%]">
                            <img
                                src={logo}
                                alt="logo"
                                className="h-[44px] w-[211px] pointer-events-none"
                            />
                        </div>
                        <div className="relative flex flex-col items-center mb-8  w-[40%]">
                            <div className="relative w-full">
                                <div className="absolute top-[18px] left-0 right-0 h-[3px] bg-[#E0E8FF] z-0 mx-4"></div>
                                <div
                                    className="absolute top-[18px] left-0 h-1 bg-gradient-to-r from-ec-primary to-[#3DE8FF] transition-all duration-1000 z-10 mx-4"
                                    style={{ width: progressWidth }}
                                ></div>
                                <div className="flex justify-between">
                                    {tabs.map((tab, index) => (
                                        <div
                                            key={index}
                                            className="relative z-10 flex flex-col items-center"
                                        >
                                            {activeTab === tab ? (
                                                <div className="relative top-[-7px]">
                                                    <div className=" bg-[#EEF2FF] border-4 border-black/10 border-l-ec-primary border-r-ec-primary border-b-ec-primary rounded-full w-[55px] h-[55px] animate-[donut-spin_4s_linear_infinite]"></div>
                                                    <div
                                                        className={`rounded-full w-10 h-10 flex items-center p-[9px] text-[16px] justify-center bg-ec-primary text-white absolute top-[8px] right-[8px]`}
                                                    >
                                                        {index + 1}
                                                    </div>
                                                </div>
                                            ) : (
                                                <div
                                                    className={`rounded-full w-10 h-10 flex items-center p-[9px] text-[16px] justify-center ${getStepClassName(
                                                        index
                                                    )}`}
                                                >
                                                    {tabs.indexOf(activeTab) >
                                                    index ? (
                                                        <img
                                                            src={check}
                                                            alt="check-icon"
                                                            className="w-[18px]"
                                                        />
                                                    ) : (
                                                        index + 1
                                                    )}
                                                </div>
                                            )}
                                            <div
                                                className={`text-center text-[16px] text-ec-secondary capitalize ${
                                                    activeTab === tab
                                                        ? "font-bold text-ec-body"
                                                        : "mt-2 "
                                                }`}
                                            >
                                                {tab.replace("/", "")}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {["/business", "/store", "/payment", "/account"].includes(activeTab) && (
         
                        <div className="mb-12 w-full">
                            <form ref={formRef} className="mb-12 w-full">
                                <div className={activeTab === "/business" ? "block" : "hidden"}>
                                    <Business formValues={formValues} setFormValues={setFormValues} />
                                </div>
                                <div className={activeTab === "/store" ? "block" : "hidden"}>
                                    <Store formValues={formValues} setFormValues={setFormValues} />
                                </div>
                                <div className={activeTab === "/payment" ? "block" : "hidden"}>
                                    <Payment formValues={formValues} setFormValues={setFormValues} />
                                </div>
                                <div className={activeTab === "/account" ? "block" : "hidden"}>
                                    <Account isAPIKeyVisible={isAPIKeyVisible} formValues={formValues} setFormValues={setFormValues} />
                                </div>
                            </form>
                            <div className="w-[40%] mt-6 mx-auto flex justify-between items-center gap-4">
                                <div>
                                    {activeTab !== defaultTab &&
                                        activeTab !== tabs[tabs.length - 1] && (
                                            <button
                                                onClick={handlePrevious}
                                                className="w-[120px] h-12 bg-transparent font-inter font-normal 
                                                text-ec-primary hover:text-white text-base leading-[26px] border 
                                                border-ec-primary rounded-lg focus:shadow-none hover:bg-ec-primary 
                                                transition-all ease-in-out duration-300"
                                            >
                                                Previous
                                            </button>
                                        )}
                                </div>

                                <div className="flex justify-end items-center gap-8">
                                    <button
                                        className="w-[80px] h-12 font-inter font-normal text-base leading-[26px]
                                        text-ec-secondary hover:text-ec-body focus:text-ec-body transition-all
                                        ease-in-out duration-300"
                                        onClick={handleSkip}
                                    >
                                        Skip
                                    </button>
                                    {activeTab !== tabs[tabs.length - 1] && (
                                        <button
                                            onClick={handleNext}
                                            className="w-[120px] h-12 font-inter bg-ec-primary group border border-ec-primary 
                                            rounded-lg text-white font-normal hover:text-white hover:bg-ec-secondary 
                                            focus:shadow-none lg:text-base md:text-xs sm:text-sm transition-all ease-in-out 
                                            duration-300 leading-[26px]"
                                        >
                                            Next
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                 
                )}

                {activeTab === "/success" && (
                    <div className="w-full h-screen">
                        <Success/>
                    </div>
                )}
            </div>
            <ToastContainer />
        </div>
    );
};
const container = document.getElementById("easycommerce_wizard_render");
const root = createRoot(container);
root.render(
    <App />
);
